import { useContext, useEffect, useState } from 'react'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import ApiContext from 'src/provider/API/call-service'
import UserContext from 'src/provider/state-manager/userProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { ScreenContainer, CustomContainer, AppSpan, AppText, AbsoluteContainer, FlexRow, GridContainer, Icon, Switch } from 'src/style'
import { 
    AccountDeletionDetailsD2,
    AccountDeletionReasonD2,
    AccountOfficerD2, AccountUpgradeD2, AcctDeletionOtherReasonD2, AcctDeletionTermsD2, 
    AddBeneficiaryD2, AuthOtpD2, ChangePasswordD2, 
    ChangePinD2, ForgotPinD2, LoginMethodChange, ManageTransactionLimitD2, 
    MyAccountD2, PanicPinSetup, ScheduledTransfersD2
} from 'src/component'
import { accountSettings, authSettings } from 'src/provider/config/constant'
import { FiChevronRight } from 'react-icons/fi'
import AlertModal from 'src/component/AlertModal'

export const SettingsD2: React.FC = () => {
    const {API} = useContext(ApiContext)
    const {user, setUserProperty} = useContext(UserContext)
    const {info: {institutionData,defaultSettingsView}, logout} = useContext(AppInfoContext)
    const {notifier} = useContext(VisibilityContext)
    const [navPosition, setNavPosition] = useState(0)
    const [settingsData, setSettingsData] = useState<any>(accountSettings)
    const [isHideBalance, setIsHideBalance] = useState(false)
    const [view, setView] = useState(defaultSettingsView)
    const [isAlert, setIsAlert] = useState(false);

    const useVerifyMe: boolean =
    institutionData?.useVerifyMeForTransactions === true &&
    user?.userInfo?.profileInfo?.isFaceVerified === false;

    useEffect(() => {
        setSettingsData(navPosition === 0 ? accountSettings : authSettings)
    }, [navPosition])

    function handleHideBalance (val: boolean) {
        notifier.show(`Balance Successfully ${!isHideBalance ? 'Hidden' : 'Unhidden'}`, '', 'success')
        setIsHideBalance(val)
    }

    async function handleAccountDeletion (hashedOtp: string) {
        await setUserProperty('acctDeletionData', {...user.acctDeletionData, otp: hashedOtp})
        const response = await API.deactivateProfile(hashedOtp)
        if (response) {
            notifier.show('Account Deleted', null, 'success')
            setView('')
            logout()
        }
    }
    
    return (
        <>
            <ScreenContainer padding='2.5' >
                <CustomContainer
                    customRadius='10px 10px 0px 0px' borderColor='#EAECF0'
                    minHeight='100' mnHUnit='%' bgColor='#FCFCFC' padding='2'
                >
                    <CustomContainer>
                        <AppSpan textSize='2.2' fontWeight='700'>Settings</AppSpan>
                        <AppText>Manage your Account and Preferences here</AppText>
                    </CustomContainer>
                    <CustomContainer
                         className='scrollable-container'
                    >
                        <CustomContainer 
                            height="4.5" topMargin="2" bottomMargin="2" 
                            width='34.4' bgColor='#F4FFFE' radius='0.5'
                        >
                            <AbsoluteContainer 
                                width='16.3'
                                left={navPosition === 0 ? '0' : '18'}
                                className='d3-toggled-wrapper'
                            >
                                <CustomContainer 
                                    bgColor="#0EA59D" height="3.6" radius='0.6'
                                />
                            </AbsoluteContainer>
                            <FlexRow 
                                zIndex="2" gap='2'
                                height='100' hUnit='%'
                            >
                                <GridContainer 
                                    height="100" hUnit='%'
                                    onClick={() => setNavPosition(0)}
                                >
                                    <AppSpan 
                                        fontWeight='600' cursor="pointer"
                                        color={navPosition === 0 ? "#ffffff" : "#667085"}
                                    >
                                        Account
                                    </AppSpan>
                                </GridContainer>
                                <GridContainer 
                                    height="100" hUnit='%'
                                    onClick={() => setNavPosition(9.7)}
                                >
                                    <AppSpan 
                                        fontWeight='600' cursor="pointer"
                                        color={navPosition === 9.7 ? "#ffffff" : "#667085"}
                                    >
                                        Authentication
                                    </AppSpan>
                                </GridContainer>
                            </FlexRow>
                        </CustomContainer>
                    </CustomContainer>
                    <FlexRow
                        topMargin='2' justify-content='space-between'
                        alignItems='flex-start' gap='2'
                        className='d3-module-row-container'
                    >
                        <CustomContainer 
                            bgColor='#ffffff' borderColor='#EAECF0'
                            width='55' sizeUnit='%' radius='0.8'
                            className='module-row-left-item'
                        >
                            {
                                settingsData?.map((item: any, index: number) => {
                                    return (
                                        <GridContainer 
                                            minHeight='7.2' key={index} padding='2'
                                            topPadding='0.5' bottomPadding='0.5'
                                            bgColor={view === item.view ? '#F4FFFE' : '#ffffff'}
                                            className='settings-item-container-d2'
                                            onClick={() => item.view === 'hide-balance' ? null : (item.view === 'account-upgrade' && useVerifyMe) ? setIsAlert(true) : setView(item.view)}
                                        >
                                            <FlexRow justifyContent='space-between' gap='1.5'>
                                                <FlexRow width='auto' sizeUnit='' gap='1.5'>
                                                    {item.icon.d1}
                                                    <CustomContainer width='auto' sizeUnit=''>
                                                        <AppSpan fontWeight='600' color='#101828'>{item.name}</AppSpan>
                                                        <AppText color='#667085'>{item.description}</AppText>
                                                    </CustomContainer>
                                                </FlexRow>
                                                { item.view != 'hide-balance' ?
                                                    <FiChevronRight 
                                                        style={{fontSize: '1.7rem', color: '#667085', flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                                    />
                                                    : 
                                                    <Switch
                                                        radius='1.17' bgColor='#F2F4F7' width='4.4' 
                                                        height='2.4' sliderWidth='2' sliderHeight='2' 
                                                        initialSliderPosition='0.2' checkedSliderPosition='2.3'
                                                        checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                                                    >
                                                        <input 
                                                            type="checkbox" 
                                                            checked={isHideBalance}
                                                            onChange={(e) => handleHideBalance(e.target.checked)} />
                                                        <div ></div>
                                                        <span></span>
                                                    </Switch>
                                                }
                                            </FlexRow>
                                        </GridContainer>
                                    )
                                })
                            }
                        </CustomContainer>
                        { view === 'my-account' &&
                            <MyAccountD2
                                close={() => setView('')}
                            />
                        }
                        { view === 'account-officer' &&
                            <AccountOfficerD2
                                close={() => setView('')}
                            />
                        }
                        { view === 'beneficiaries' &&
                            <AddBeneficiaryD2
                                close={() => setView('')}
                            />
                        }
                        { view === 'tx-limit' &&
                            <ManageTransactionLimitD2
                                close={() => setView('')}
                            />
                        }
                        { view === 'scheduled-tx' &&
                            <ScheduledTransfersD2
                                close={() => setView('')}
                            />
                        }
                        { view === 'account-upgrade' &&
                            <AccountUpgradeD2
                                close={() => setView('')}
                                verifyMe={useVerifyMe}
                            />
                        }
                        { view === 'panic-pin' &&
                            <PanicPinSetup
                                close={() => setView('')}
                            />
                        }
                        { view === 'change-pin' &&
                            <ChangePinD2
                                close={() => setView('')}
                            />
                        }
                        { view === 'change-password' &&
                            <ChangePasswordD2
                                close={() => setView('')}
                            />
                        }
                        { view === 'forgot-pin' &&
                            <ForgotPinD2
                                close={() => setView('')}
                            />
                        }
                        { view === 'acct-deletion-details' &&
                            <AccountDeletionDetailsD2
                                close={() => setView('')}
                                back={() => setView('account-deletion')}
                                next={() => setView('acct-delete-reason')}
                            />
                        }
                        { view === 'acct-delete-reason' &&
                            <AccountDeletionReasonD2 
                                close={() => setView('')}
                                back={() => setView('acct-deletion-details')}
                                next={(screen: string) => setView(screen)}
                            />
                        }
                        { view === 'other-reasons' &&
                            <AcctDeletionOtherReasonD2 
                                close={() => setView('')}
                                back={() => setView('acct-delete-reason')}
                                next={() => setView('otp-validation')}
                            />
                        }
                    </FlexRow>

                    {isAlert && (
                            <AlertModal
                                title={"Verify your Account"}
                                body={
                                    "To ensure secure transactions, please complete the verification process before upgrading your account. This helps us protect your account and maintain a safe platform for everyone."
                                }
                                close={() => setIsAlert(false)}
                                next={() => {
                                    setIsAlert(false)
                                    setView('account-upgrade')
                                }}
                            />
                        )}
                </CustomContainer>
            </ScreenContainer>
            {/* { view === 'login-method-change' &&
                <LoginMethodChange
                    close={() => setView('')}
                />
            } */}
            { view === 'account-deletion' &&
                <AcctDeletionTermsD2
                    close={() => setView('')}
                    next={() => setView('acct-deletion-details')}
                />
            }
            { view === 'otp-validation' &&
                <AuthOtpD2
                    close={() => setView('')}
                    back={() => setView('acct-delete-reason')}
                    next={(otp: string) => handleAccountDeletion(otp)} 
                    resendOtp={() => API.sendProfileDeactivationOtp()}
                />
            }
        </>
    )
}